package org.chiangmeng.qfast.database

import kotlin.Long
import kotlin.String

public data class QueueHistoryEntity(
  public val id: Long,
  public val shop_id: String,
  public val ticket_number: Long,
  public val served_at: Long,
)
